import React, { useState } from "react";
import { formatLocalDateTime } from "../../utils/dateTime";
import { formatLiveValue, isStringLiveValue, numericLiveValue } from "../../utils/tagValue";

const IOCard = ({ tag, latestMap, onSetAnalog, readOnly = false }) => {
  const latest = latestMap?.[tag.name];

  const numeric = numericLiveValue(latest);
  const currentText = isStringLiveValue(latest) ? formatLiveValue(latest) : (numeric !== null ? numeric.toFixed(2) : "N/A");
  const ts = latest?.timestamp ?? "N/A";

  const [inputValue, setInputValue] = useState("");
  const [sending, setSending] = useState(false);
  const [localErr, setLocalErr] = useState("");

  const submit = async () => {
    setLocalErr("");
    if (inputValue === "" || isNaN(inputValue)) {
      setLocalErr("عدد معتبر وارد کن");
      return;
    }

    setSending(true);
    try {
      await onSetAnalog(tag.id, Number(inputValue));
      setInputValue("");
    } catch (e) {
      setLocalErr("ارسال مقدار ناموفق بود");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="dg-card">
      <div className="dg-card-head">
        <div className="dg-card-title">{tag.name}</div>
        <div className="dg-card-sub">ID: {tag.id}</div>
      </div>

      <div className="dg-row">
        <span className="dg-label">Current</span>
        <span className="dg-value-strong">{currentText}</span>
      </div>

      {!readOnly ? <div className="dg-io">
        <input
          className="dg-input"
          placeholder="Set value..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button className="dg-btn" onClick={submit} disabled={sending || inputValue === ""}>
          {sending ? "Sending..." : "Set"}
        </button>
      </div> : <div className="dg-read-only">Read only</div>}

      {localErr && <div className="dg-local-error">{localErr}</div>}

      <div className="dg-row">
        <span className="dg-label">Timestamp</span>
        <span className="dg-value-soft">{formatLocalDateTime(ts)}</span>
      </div>
    </div>
  );
};

export default IOCard;
